export default {
  productId: "Product #", // 864-50-109",
  brand: "Brand", // "Hooker Furniture",
  material: "Material", // Hardwood Solids with Cherry, White Oak and White Ash Burl Veneers",
  introducedOn: "Introduced On", // 2005-04-01T00:00:00.0000000Z",
  size: "Size", // 16.63",
  cartonSize: "Carton Size", // 17.00",
  packaging: "Packaging", // 1 per carton",
  collection: "Collection", // PrestonRidge",
  carton: "Carton", // 16.63 x 19.38 x 26.38",
  dimensions: "Dimensions", // 13.00 x 17.00 x 24.25",
  usDate1: false, // "US Date 1", // Date:12/31/2018 -Qty:10.00 -Status:Purchase Order",
  ovSeaInStock: false, // Asia:23",
  ovSeaDate1: false, // Asia:Date:01/28/2019 -Qty:50.00 -Status:Purchase Order",
  suggestedRetail: "MSRP", // $677",
  factory: "Factory", // Fookyik Furniture International Company Limted",
  cartonWeight: "Weight", //48.0,
  productLineId: "Product Line", // HFC",
  manufacturerNumber: "Mfg #", // 864-50-109",
  shortDescription: "Product Name", // memDescription
  longDescription: "Description", // memDescription2
  altDescription: "Romance Description", // memDescription3
  upcCode: "UPC", // 793532108275",
  status: "Status", // Active",
  listPrice: "List Price", // 0,
  wholesalePrice: "Wholesale Price", // 205,
  retailPrice: "Retail Price", // 677,
  retailListPrice: "MSRP", // 0,
  unitsInStock: "Units In Stock", // 60,
  price: "Price", // 205,
  displayListPrice: "Display List Price",
  displaySalesPrice: "Display Sales Price",
  categoryId: "Category", // Accents",
  minimumOrderQty: "Min Qty", // 1,
  availableQty: "Available Qty", // 60,
  availableOn: false,
  incomingQty: "Incoming Qty", // 0,
  purchaseIncrement: "Purchase Increment", // 0,
  vendorId: "Vendor", // HFC",
  itemType: "Type", // "",
  superCategory: "Super-Category", // "Small Accents",
  tags: "Tags",
  isNew: "New", //false,
  isRestricted: true,
  isOnDemand: false,
  createdOn: "Created On", //"0001-01-01T00:00:00.0000000Z",
  weight: "Net Weight", // 39.69,
  height: "Height", // 0,
  length: "Length", //0,
  cubicVolume: "Cubic ft.", //4.92,
  caseQty: "Case Qty",
  cost: "Cost", //0,
  uom: "UOM", // "EA",
  subCategory: "Sub-Category", //"PrestonRidge",
  featured: "Featured", // 0,
  keywords: "Keywords", // 0,
  optionGroup: "Option Group",
  optionGroupList: "Option Group List",
  likes: "Likes", //0,
  isB2C: "B2C Sellable",
  isB2B: "B2B Sellable",
  // <product-images-toolbar/>
  mediaTab: "Media",
  invoiceTab: "Invoice History",
  addImages: "Add Image(s)...",
  manageImages: "Remove/Reorder Images...",
  inStock: "In Stock",
  outOfStock: "Out of Stock",
  prevProduct: "chevron-left",
  nextProduct: "chevron-right",
};
